import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `หน้าแรก ${ctx.brand} ภาษาไทย`,
    languageButtonLabel: `ภาษา`,
    languageModalTitle: `เลือกภาษา`,
    languageModalCloseLabel: `ปิดเมนูภาษา`,
  },
  languageOptions: {
    'en-US': {
      label: `อังกฤษ`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `อังกฤษ (เคนยา)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `อังกฤษ (ไนจีเรีย)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `อังกฤษ (สิงคโปร์)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `โปรตุเกส`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `เยอรมัน`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `สเปน`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `ฝรั่งเศส`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `อิตาลี`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `ดัตช์`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `นอร์ดิกและบอลติก`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `ญี่ปุ่น`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `เกาหลี`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `จีนกลาง`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `จีนกวางตุ้ง`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `ไทย`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `ฮินดี`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `เปอร์เซีย`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `รัสเซีย`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `อาหรับ`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `อาหรับโมร็อกโก`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `เลือกภาษา`,
    closeLabel: `ปิดเมนูภาษา`,
  },
  languageHint: (ctx) => `สลับข้ามได้มากกว่า ${ctx.localesCount}+ ภาษาในคลิกเดียว`,
  readPagePrompt: ({languageLabel}) => `อ่านหน้านี้เป็น${languageLabel}.`,
};
